var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActionExternalLink = function SvgActionExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.498A.5.5 0 0 1 16.5 3H21v4.564a.499.499 0 0 1-1 0v-2.78l-6.146 6.118-.708-.704 6.232-6.203H16.5a.5.5 0 0 1-.5-.497"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.07c-.828 0-1.5.67-1.5 1.494v10.948c0 .824.672 1.493 1.5 1.493h11c.828 0 1.5-.669 1.5-1.493v-7.465h1v7.465A2.494 2.494 0 0 1 16.5 21h-11C4.12 21 3 19.886 3 18.512V7.564a2.494 2.494 0 0 1 2.5-2.488H13v.995H5.5Z"
  })));
};
export default SvgActionExternalLink;